import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faAngleDown,
  faAngleUp,
  faBars,
  faTimes,
}
  from '@fortawesome/free-solid-svg-icons';
import { Link } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';

import './style.css';

const Navbar = ({ bgSmall, language }) => {
  console.info(language);

  const [navbarOpen, setNavbarOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  if (language === 'en') {
    return (
      <>
        <nav className="flex flex-wrap items-center bg-primary py-4 mb-0 mx-auto nav-sticky">
          <div className="container px-0 mx-auto flex flex-wrap items-center">
            <div className="w-full relative flex justify-between lg:w-auto lg:static lg:block lg:justify-start">
              <div className="w-full py-2 px-9 z-30 lg:px-15">
                <StaticImage
                  src="../../images/komunal-logo.png"
                  alt="Komunal-Logo"
                  className="w-28 h-auto"
                  placeholder="none"
                  objectFit="contain"
                />
              </div>
              <button
                className="text-white cursor-pointer text-xl z-30
                  leading-none px-7 py-1 border border-solid border-transparent
                  rounded bg-transparent block lg:hidden outline-none focus:outline-none"
                type="button"
                onClick={() => setNavbarOpen(!navbarOpen)}
              >
                {!navbarOpen && <FontAwesomeIcon icon={faBars} />}
                {navbarOpen && <FontAwesomeIcon icon={faTimes} />}
              </button>
            </div>
            <div className={` lg:flex flex-grow py-7 px-4 lg:px-15 lg:justify-end lg:py-2 items-center
                                      ${navbarOpen ? 'flex' : 'hidden'} z-30 bg-${bgSmall}
                                  `}
            >
              <ul className="flex flex-col items-start lg:items-end lg:flex-row list-none lg:ml-auto">
                <li className="nav-item">
                  <Link
                    className="lg:px-4 py-2 flex items-center text-sm font-normal leading-snug text-white lg:text-blue hover:opacity-75 border-bottom-white"
                    to={`/${language}`}
                    activeClassName="active-navbar"
                  >
                    <i className="fab fa-pinterest text-lg leading-lg text-blue opacity-75" />
                    <span>Home</span>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="lg:px-4 py-2 pt-4 lg:pt-0 flex items-center text-sm font-normal
                    leading-snug text-white lg:text-blue hover:opacity-75 border-bottom-white"
                    to={`/${language}/aboutUs`}
                    activeClassName="active-navbar"
                  >
                    <i className="fab fa-pinterest text-lg leading-lg text-blue opacity-75" />
                    <span>About Us</span>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="lg:px-4 py-2 pt-4 lg:pt-0 flex items-center text-sm font-normal
                    leading-snug text-white lg:text-blue hover:opacity-75 border-bottom-white"
                    to={`/${language}/products`}
                    activeClassName="active-navbar"
                  >
                    <i className="fab fa-pinterest text-lg leading-lg text-blue opacity-75" />
                    <span>Products</span>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="lg:px-4 py-2 pt-4 lg:pt-0 flex items-center text-sm font-normal
                    leading-snug text-white lg:text-blue hover:opacity-75 border-bottom-white"
                    to={`/${language}/youngforce`}
                    activeClassName="active-navbar"
                  >
                    <i className="fab fa-pinterest text-lg leading-lg text-blue opacity-75" />
                    <span>Community</span>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="lg:px-4 py-2 pt-4 lg:pt-0 flex items-center text-sm font-normal
                    leading-snug text-white lg:text-blue hover:opacity-75 border-bottom-white"
                    to={`/${language}/contact`}
                    activeClassName="active-navbar"
                  >
                    <i className="fab fa-pinterest text-lg leading-lg text-blue opacity-75" />
                    <span>Contact Us</span>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="lg:px-4 py-2 pt-4 lg:pt-0 flex items-center text-sm font-normal
                    leading-snug text-white lg:text-blue hover:opacity-75 border-bottom-white"
                    to={`/${language}/blog`}
                    activeClassName="active-navbar"
                  >
                    <i className="fab fa-pinterest text-lg leading-lg text-blue opacity-75" />
                    <span>Blog</span>
                  </Link>
                </li>
                <li className="relative mt-5 lg:mt-0">
                  <button
                    className="lg:pl-4 py-2 pt-4 lg:pt-0 flex items-center text-sm font-normal
                    leading-snug text-white lg:text-blue hover:opacity-75 border-bottom-white"
                    type="button"
                    onClick={() => setDropdownOpen(!dropdownOpen)}
                  >
                    <StaticImage
                      src="../../images/globe.png"
                      alt="globe"
                      className="w-5 h-5 mr-2"
                      placeholder="none"
                      objectFit="contain"
                    />
                    <i className="fab fa-pinterest text-lg leading-lg text-blue opacity-75" />
                    <span>EN</span>
                    <div className="relative right-0 pl-2 lg:pl-2 lg:relative">
                      {!dropdownOpen && <FontAwesomeIcon icon={faAngleDown} />}
                      {dropdownOpen && <FontAwesomeIcon icon={faAngleUp} />}
                    </div>
                  </button>
                  <div
                    className={`${dropdownOpen ? 'block' : 'hidden'} lg:absolute right-0 mt-2 py-2 lg:bg-white lg:rounded-lg lg:shadow-xl`}
                  >
                    <a
                      href="/en/"
                      className="block px-5 py-2 hover:bg-gray-300 lg:text-black text-white"
                    >
                      EN
                    </a>
                    <a
                      href="/id/"
                      className="block px-5 py-2 hover:bg-gray-300 lg:text-black text-white"
                    >
                      ID
                    </a>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </>
    );
  } return (
    <>
      <nav className="flex flex-wrap items-center bg-primary py-4 mb-0 mx-auto nav-sticky">
        <div className="container px-0 mx-auto flex flex-wrap items-center">
          <div className="w-full relative flex justify-between lg:w-auto lg:static lg:block lg:justify-start">
            <div className="w-full py-2 px-9 z-30 lg:px-0">
              <StaticImage
                src="../../images/komunal-logo.png"
                alt="Komunal-Logo"
                className="w-28 h-auto"
                placeholder="none"
                objectFit="contain"
              />
            </div>
            <button
              className="text-white cursor-pointer text-xl z-30
                  leading-none px-7 py-1 border border-solid border-transparent
                  rounded bg-transparent block lg:hidden outline-none focus:outline-none"
              type="button"
              onClick={() => setNavbarOpen(!navbarOpen)}
            >
              {!navbarOpen && <FontAwesomeIcon icon={faBars} />}
              {navbarOpen && <FontAwesomeIcon icon={faTimes} />}
            </button>
          </div>
          <div className={` lg:flex flex-grow py-7 px-4 lg:px-0 lg:justify-end lg:py-2 items-center
                                      ${navbarOpen ? 'flex' : 'hidden'} z-30 bg-${bgSmall}
                                  `}
          >
            <ul className="flex flex-col items-start lg:items-end lg:flex-row list-none lg:ml-auto">
              <li className="nav-item">
                <Link
                  className="lg:px-4 py-2 flex items-center text-sm font-normal leading-snug text-white lg:text-blue hover:opacity-75 border-bottom-white"
                  to={`/${language}`}
                  activeClassName="active-navbar"
                >
                  <i className="fab fa-pinterest text-lg leading-lg text-blue opacity-75" />
                  <span>Beranda</span>
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="lg:px-4 py-2 pt-4 lg:pt-0 flex items-center text-sm font-normal
                  leading-snug text-white lg:text-blue hover:opacity-75 border-bottom-white"
                  to={`/${language}/aboutUs`}
                  activeClassName="active-navbar"
                >
                  <i className="fab fa-pinterest text-lg leading-lg text-blue opacity-75" />
                  <span>Tentang Kami</span>
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="lg:px-4 py-2 pt-4 lg:pt-0 flex items-center text-sm font-normal
                  leading-snug text-white lg:text-blue hover:opacity-75 border-bottom-white"
                  to={`/${language}/products`}
                  activeClassName="active-navbar"
                >
                  <i className="fab fa-pinterest text-lg leading-lg text-blue opacity-75" />
                  <span>Produk</span>
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="lg:px-4 py-2 pt-4 lg:pt-0 flex items-center text-sm font-normal
                  leading-snug text-white lg:text-blue hover:opacity-75 border-bottom-white"
                  to={`/${language}/youngforce`}
                  activeClassName="active-navbar"
                >
                  <i className="fab fa-pinterest text-lg leading-lg text-blue opacity-75" />
                  <span>Komunitas</span>
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="lg:px-4 py-2 pt-4 lg:pt-0 flex items-center text-sm font-normal
                  leading-snug text-white lg:text-blue hover:opacity-75 border-bottom-white"
                  to={`/${language}/contact`}
                  activeClassName="active-navbar"
                >
                  <i className="fab fa-pinterest text-lg leading-lg text-blue opacity-75" />
                  <span>Kontak Kami</span>
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="lg:px-4 py-2 pt-4 lg:pt-0 flex items-center text-sm font-normal
                  leading-snug text-white lg:text-blue hover:opacity-75 border-bottom-white"
                  to={`/${language}/blog`}
                  activeClassName="active-navbar"
                >
                  <i className="fab fa-pinterest text-lg leading-lg text-blue opacity-75" />
                  <span>Blog</span>
                </Link>
              </li>
              <li className="relative mt-5 lg:mt-0">
                <button
                  className="lg:pl-4 py-2 pt-4 lg:pt-0 flex items-center text-sm font-normal
                  leading-snug text-white lg:text-blue hover:opacity-75 border-bottom-white"
                  type="button"
                  onClick={() => setDropdownOpen(!dropdownOpen)}
                >
                  <StaticImage
                    src="../../images/globe.png"
                    alt="globe"
                    className="w-5 h-5 mr-2"
                    placeholder="none"
                    objectFit="contain"
                  />
                  <i className="fab fa-pinterest text-lg leading-lg text-blue opacity-75" />
                  <span>ID</span>
                  <div className="relative right-0 pl-2 lg:pl-2 lg:relative">
                    {!dropdownOpen && <FontAwesomeIcon icon={faAngleDown} />}
                    {dropdownOpen && <FontAwesomeIcon icon={faAngleUp} />}
                  </div>
                </button>
                <div
                  className={`${dropdownOpen ? 'block' : 'hidden'} lg:absolute right-0 mt-2 py-2 lg:bg-white lg:rounded-lg lg:shadow-xl`}
                >
                  <a
                    href="/en/"
                    className="block px-5 py-2 lg:text-black text-white hover:bg-gray-300"
                  >
                    EN
                  </a>
                  <a
                    href="/id/"
                    className="block px-5 py-2 lg:text-black text-white hover:bg-gray-300"
                  >
                    ID
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </nav>

    </>
  );
};

Navbar.propTypes = {
  bgSmall: PropTypes.string,
  language: PropTypes.string,
};

Navbar.defaultProps = {
  bgSmall: 'primary',
  language: 'en',
};

export default Navbar;
